// components/ImageUploadField.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  IconButton,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import axios from "axios";

const ImageUploadField = ({ label, value, onChange, hint = "" }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError("");
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("image", file);

      const res = await axios.post(`${apiUrl}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      onChange(res.data.url); // full URL backend se aaya
    } catch (err) {
      setError("Upload failed. Try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleClear = () => onChange("");

  return (
    <Box mb={2}>
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        mb={0.5}
      >
        {label}
      </Typography>

      {/* Preview — agar URL exist kare */}
      {value && (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          mb={1}
          p={1}
          sx={{
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <img
            src={value}
            alt="preview"
            width={56}
            height={56}
            style={{ objectFit: "cover", borderRadius: 6 }}
          />
          {/* Typography wali line bilkul delete kar di kioun ky path nahi dikhana */}
          <IconButton
            size="small"
            color="error"
            onClick={handleClear}
            sx={{ ml: "auto" }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* Upload button */}
      <Button
        component="label"
        variant="outlined"
        startIcon={
          uploading ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <UploadFileIcon fontSize="small" />
          )
        }
        disabled={uploading}
        sx={{
          borderStyle: "dashed",
          borderRadius: "8px",
          textTransform: "none",
          color: "text.secondary",
          fontSize: "13px",
          "&:hover": {
            borderStyle: "dashed",
            color: "#3b82f6",
            borderColor: "#3b82f6",
          },
        }}
      >
        {uploading ? "Uploading..." : value ? "Replace Image" : "Upload Image"}
        <input
          type="file"
          accept="image/*"
          hidden
          onChange={handleFileChange}
        />
      </Button>

      {hint && (
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          mt={0.5}
        >
          {hint}
        </Typography>
      )}
      {error && (
        <Typography variant="caption" color="error" display="block" mt={0.5}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ImageUploadField;
